import {EXTRA_DOM_LOADED_EVENT, REGISTER_COMPONENT} from "./constants/custom-events";
import {READY_STATE_CHANGE, READY_STATE_CHANGE_INTERACTIVE, READY_STATE_LOADING} from "./constants/events";
import BaseComponent from "./components/base-component";

/**
 * @author Jonas.Fournel
 * @fileOverview
 */
export default class ElementClassLoader {

    componentMapping:Map<string, any> = new Map<string, string>()
    components:Array<BaseComponent> = [];
    loadedModules:Array<string> = [];

    constructor() {
        this.components = [];

        document.addEventListener(REGISTER_COMPONENT, (event) =>
            this.registerImplementation(event as CustomEvent)
        );

        [EXTRA_DOM_LOADED_EVENT].forEach((event) => {
            document.addEventListener(event, () => {
                this.loadComponents();
            })
        })

        if (document.readyState === READY_STATE_LOADING) {
            document.addEventListener(READY_STATE_CHANGE, () => {
                if (document.readyState === READY_STATE_CHANGE_INTERACTIVE) {
                    this.loadComponents();
                }
            });
        } else {
            this.loadComponents();
        }
    }

    registerImplementation(event:CustomEvent) {
        if (event && event.detail) {
            const nameSpace = event.detail.classNameSpace;
            const {clazz} = event.detail;
            if (!this.componentMapping.has(nameSpace)) {
                this.componentMapping.set(nameSpace, clazz);
            } else {
                console.debug(`${nameSpace} already registered in component class loader, ignoring`);
            }
        }
    }

    loadComponents() {
        const elements = document.querySelectorAll("[data-mesh]:not([data-hydrated='true']):not([data-complex='false'])");
        elements.forEach(async element => {
            const htmlElement = element as HTMLElement;
            if(!htmlElement.dataset?.complex && !htmlElement.dataset.hydrated) {
                if(!this.loadedModules.includes(htmlElement.dataset?.mesh!)) {
                    await import(`/commons/${window.coreVersion}/${htmlElement.dataset?.mesh}-${window.coreVersion}.js`)
                        .then((module) => {
                            this.loadedModules.push(module.default.CLASS_NAMESPACE);
                        })
                }
                const clazz = this.getImplementation(htmlElement.dataset?.mesh!);
                const instance = new clazz(htmlElement, htmlElement.dataset?.mesh!);
                instance.initialize();
                this.components.push(instance);
                htmlElement.dataset.hydrated = 'true';
            }
        })
    }

    getComponent(componentName:string):BaseComponent | undefined {
        return this.components.find(e => e.componentName === componentName);
    }

    getImplementation(classNameSpace:string) {
        const element = this.componentMapping.get(classNameSpace);
        if (element) {
            return element;
        }
        console.error(`No implementation found in existing component mapping for namespace '${classNameSpace}'`);
    }

    getComponentMapping() {
        return this.componentMapping;
    }
}
